<template>
	<v-card class="d-flex flex-column">
		<v-toolbar color="primary" dark flat>
			<v-toolbar-title> Confirm ClinicalTrials.gov study </v-toolbar-title>
		</v-toolbar>

		<v-data-table
			class="pa-5"
			:items="previewDisplay"
			:items-per-page="-1"
			hide-default-header
			hide-default-footer
			:loading="loading"
		>
			<template #item.label="{ item }">
				<td width="150px">
					{{ item.label }}
				</td>
			</template>
		</v-data-table>

		<v-card-text class="pt-0 text-body-2 text-fg-2">
			Importing attaches the registry data to this paper; a new extraction on it
			opens pre-filled from the posted results.
		</v-card-text>

		<v-card-actions class="my-8">
			<v-spacer />

			<v-btn
				class="bg-secondary"
				:disabled="loading"
				elevation="2"
				@click="$emit('confirm')"
			>
				Import this study
			</v-btn>

			<v-btn class="bg-grey" elevation="2" @click="$emit('cancel')">
				Cancel
			</v-btn>

			<v-spacer />
		</v-card-actions>
	</v-card>
</template>

<script>
const orderedList = [
	{ key: "nctId", text: "NCT ID" },
	{ key: "briefTitle", text: "Brief title" },
	{ key: "officialTitle", text: "Official title" },
	{ key: "leadSponsor", text: "Lead sponsor" },
	{ key: "overallStatus", text: "Status" },
	{ key: "completionDate", text: "Completion date" },
	{ key: "hasResults", text: "Results posted" },
];

export default {
	name: "CtgovImportConfirm",

	props: {
		loading: Boolean,
		preview: { type: Object, default: () => null },
	},
	emits: ["confirm", "cancel"],

	computed: {
		previewDisplay() {
			return orderedList.map((item) => {
				let value = this.preview?.[item.key] ?? "";
				if (item.key === "hasResults") {
					value = value ? "Yes" : "No";
				}
				return {
					label: item.text,
					value: value,
				};
			});
		},
	},
};
</script>
